export default {
  methods: {
    getLocalePrefix() {
      return this.$i18n.locale === this.$i18n.defaultLocale ? '' : `/${this.$i18n.locale}`;
    }
  }
};
